import { useCallback, useState } from "react";
import closeIcon from "../../assets/pictures/icons/close-icon.svg";
import type { ModalProps } from "../../utils";
import styles from "./FeedbackNPS.module.scss";

const MAX_RATING = 5;

const Star = ({
	star,
	isFilled,
	onMouseEnter,
	onMouseLeave,
	onClick,
}: {
	star: number;
	isFilled: boolean;
	onMouseEnter: () => void;
	onMouseLeave: () => void;
	onClick: () => void;
}) => (
	<svg
		key={star}
		xmlns="http://www.w3.org/2000/svg"
		width="41"
		height="39"
		viewBox="0 0 41 39"
		fill={isFilled ? "#fac818" : "#70737A"}
		className={isFilled ? styles.glow : ""}
		onMouseEnter={onMouseEnter}
		onMouseLeave={onMouseLeave}
		onClick={onClick}
		role="button"
	>
		<path d="M19.9707 1.30815C20.2117 0.566197 21.2614 0.566198 21.5025 1.30815L25.6184 13.9755C25.7262 14.3073 26.0354 14.532 26.3843 14.532H39.7035C40.4836 14.532 40.808 15.5302 40.1768 15.9888L29.4014 23.8176C29.1191 24.0227 29.001 24.3862 29.1088 24.718L33.2247 37.3854C33.4658 38.1273 32.6166 38.7443 31.9854 38.2857L21.2099 30.4569C20.9277 30.2518 20.5455 30.2518 20.2632 30.4569L9.48774 38.2857C8.85659 38.7443 8.0074 38.1273 8.24847 37.3854L12.3643 24.718C12.4721 24.3862 12.354 24.0227 12.0718 23.8176L1.2963 15.9888C0.66516 15.5302 0.989526 14.532 1.76966 14.532H15.0889C15.4378 14.532 15.747 14.3073 15.8548 13.9755L19.9707 1.30815Z" />
	</svg>
);

const FeedbackNPS: React.FC<ModalProps> = ({ onClose }) => {
	const [rating, setRating] = useState<number>(0);
	const [hover, setHover] = useState<number>(0);

	const handleMouseEnter = useCallback((star: number) => setHover(star), []);
	const handleMouseLeave = useCallback(() => setHover(0), []);
	const handleClick = useCallback((star: number) => setRating(star), []);

	return (
		<div className={styles.content}>
			<button className={styles.buttonClose} type="button" onClick={onClose}>
				<img src={closeIcon} alt="close" />
			</button>
			<div className={styles.text}>
				<h2>Оцените нас</h2>
				<span>Это поможет сделать нашу работу лучше</span>
			</div>
			<div className={styles.stars}>
				{[...Array(MAX_RATING)].map((_, index) => {
					const star = index + 1;
					return (
						<Star
							key={star}
							star={star}
							isFilled={star <= (hover || rating)}
							onMouseEnter={() => handleMouseEnter(star)}
							onMouseLeave={handleMouseLeave}
							onClick={() => handleClick(star)}
						/>
					);
				})}
			</div>
			<button
				className={styles.buttonSubmit}
				type="submit"
				disabled={rating === 0}
			>
				Оценить
			</button>
		</div>
	);
};

export default FeedbackNPS;
